import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Button,
} from "@mui/material";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

export default function Team() {
  const underPerformers = [] as {
    user: string;
    region: string;
    activation: string;
    firstTxnAge: number;
    signUps: number;
  }[];
  // { user: "John Doe", region: "North", activation: "22%", firstTxnAge: 6, signUps: 5 },
  // { user: "Shawn Charles", region: "West", activation: "25%", firstTxnAge: 8, signUps: 4 },
  // { user: "Sasha Tucker", region: "South", activation: "32%", firstTxnAge: 11, signUps: 2 },

  const downlineUsers = [] as {
    name: string;
    role: string;
    contact: string;
    territory: string;
    affiliates: number;
    active: number;
    transactionValue: string;
    commission: string;
    netPayable: string;
  }[];

  const chartOptions: ApexOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: ["#0055FF", "#22CC88"],
    legend: {
      show: false,
    },
    grid: {
      borderColor: "#e5e7eb",
      strokeDashArray: 0,
    },
    xaxis: {
      labels: { show: true },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { show: true },
      axisBorder: { show: true, color: "#e5e7eb" }, // left line only
      axisTicks: { show: false },
    },
  };

  const chartSeries = [
    { data: [200, 300, 250, 400] },
    { data: [150, 200, 180, 320] },
  ];

  return (
    <Box sx={{ minHeight: "calc(100vh - 100px)" }}>
      {/* Top Section */}
      <Box display="grid" gridTemplateColumns={{ md: "1fr 1fr" }} gap={3}>
        {/* Under-performers */}
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Under-performers - Attention Needed
            </Typography>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Region</TableCell>
                    <TableCell>Activation %</TableCell>
                    <TableCell>First Txn Age</TableCell>
                    <TableCell>Sign ups (30d)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {underPerformers.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>{row.user}</TableCell>
                      <TableCell>{row.region}</TableCell>
                      <TableCell>{row.activation}</TableCell>
                      <TableCell>{row.firstTxnAge}</TableCell>
                      <TableCell>{row.signUps}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>

        {/* Team Trend Chart */}
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Team Trend
            </Typography>
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="line"
              height={280}
            />
          </CardContent>
        </Card>
      </Box>

      {/* Downline Users Table */}
      <Box mt={3}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Downline Users
            </Typography>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Contact</TableCell>
                    <TableCell>Territory</TableCell>
                    <TableCell>Affiliates</TableCell>
                    <TableCell>Active</TableCell>
                    <TableCell>Transaction Value</TableCell>
                    <TableCell>Commission</TableCell>
                    <TableCell>Net Payable</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {downlineUsers.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.role}</TableCell>
                      <TableCell>
                        {row.contact.split("\n").map((line, i2) => (
                          <div key={i2}>{line}</div>
                        ))}
                      </TableCell>
                      <TableCell>{row.territory}</TableCell>
                      <TableCell>{row.affiliates}</TableCell>
                      <TableCell>{row.active}</TableCell>
                      <TableCell>{row.transactionValue}</TableCell>
                      <TableCell>{row.commission}</TableCell>
                      <TableCell>{row.netPayable}</TableCell>
                      <TableCell>
                        <Button variant="outlined" size="small">
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
